const NotFound = () => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 'calc(100vh - 70px)',
      textAlign: 'center'
    }}>
      <h1 style={{ fontSize: '72px', color: '#7c3aed', margin: '0' }}>404</h1>
      <p style={{ fontSize: '18px', color: '#666', marginTop: '16px' }}>
        Page non trouvée
      </p>
    </div>
  );
};

const PlaceholderPage = ({ title }) => {
  return (
    <div style={{ padding: '24px' }}>
      <h1 style={{ 
        fontSize: '28px', 
        fontWeight: 'bold', 
        color: '#1f2937',
        marginBottom: '24px'
      }}>
        {title}
      </h1>
      <div style={{
        background: 'white',
        padding: '48px',
        borderRadius: '12px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        textAlign: 'center',
        color: '#9ca3af'
      }}>
        Module en cours de développement
      </div>
    </div>
  );
};

export { NotFound, PlaceholderPage };